import { LandingCreate } from './LandingCreate'
import { LandingEdit } from './LandingEdit'
import { LandingList } from './LandingList'
import { LandingShow } from './LandingShow'

export { LandingCreate, LandingEdit, LandingList, LandingShow }